import type { CSSProperties } from 'react'

// Dotted underline that marks a term as having a tooltip. Uses
// `text-decoration` rather than a bottom border so it underlines every line of
// wrapped text (a border only draws under the element's bottom edge, which
// leaves multi-line labels underlined just once).
export const dottedUnderlineStyle: CSSProperties = {
  textDecorationLine: 'underline',
  textDecorationStyle: 'dotted',
  textDecorationColor: 'var(--shade-30)',
  textDecorationThickness: 2,
  textUnderlineOffset: 5,
}
